import { VscLoading } from 'react-icons/vsc';
import styled from 'styled-components';

const StyledLoadingComponent = styled.div`
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    font-size: 64px;
    color: #007bff;
  }
`;
function LoadingComponent() {
  return (
    <StyledLoadingComponent>
      <VscLoading className="spin" />
    </StyledLoadingComponent>
  );
}

export default LoadingComponent;
